module.exports = __webpack_public_path__ + "static/littleWomen1s-d3f9484f90e43429e1ea35e406531980.jpg";